<template>
    <div id="document-notes-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="font-weight-bold">Notes</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>   
                </div>
                <div class="modal-body">
                    <document-notes ref="notes" modal></document-notes>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        show: function (clientId, claimId, documentId, documentTypeId, historical) {

            this.$refs.notes.init(clientId, claimId, documentId, documentTypeId, historical);
            $('#document-notes-modal').modal('show');
        }      
    },
    created() {
        eventHub.$on('show-document-notes', this.show);      
    },
    beforeDestroy() {
        eventHub.$off('show-document-notes');
    }          
}
</script>

<style scoped>

</style>